import React from 'react';
import GridStyles from '../Components/DataGrid/WorklistDataGrid.module.scss';
import { AlignedReportValue } from '@/Pages/GenericWorklist/Logic/WorklistReportAlignmentHelper';

export interface ReportTextRowValue {
    text: string;
    isOrderTypeReport: boolean;
}

export const renderAlignedReportText = (rows: readonly AlignedReportValue<ReportTextRowValue>[]): React.ReactElement => {
    const orderTypeRow = rows.find((row) => row.value.isOrderTypeReport);
    if (orderTypeRow) {
        return (
            <div className={GridStyles['order-type-report-cell']}>
                {orderTypeRow.value.text}
            </div>
        );
    }

    const renderedRows = rows.map((row) => (
        <div key={row.key} className={GridStyles['order-procedure-cell_content']}>{row.value.text}</div>
    ));

    return (
        <div className={GridStyles['order-procedure-cell']}>
            {renderedRows}
        </div>
    );
};
